export const PulseLoader = () => {
    return (
        <div className="relative w-10 h-10 m-auto">
            <div className="absolute top-0 left-0 w-full h-full rounded-full bg-support-purple-100 opacity-60 animate-loader-scale"></div>
            <div className="absolute top-0 left-0 w-full h-full rounded-full bg-support-purple-100 opacity-60 animate-loader-scale delay-1000"></div>
        </div>
    );
}